document.addEventListener('DOMContentLoaded', function () {
  let raw;
  try { raw = sessionStorage.getItem('last_collection'); } catch (e) { return; }
  if (!raw) return;

  try {
    JSON.parse(raw); // validate
  } catch (e) {
    try { sessionStorage.removeItem('last_collection'); } catch (_) {}
    return;
  }

  try { sessionStorage.removeItem('last_collection'); } catch (_) {}
});